/**
 * Map an activity's unit to a Climatiq `unit_type` filter for the
 * factor-search endpoint.
 *
 * Mirrors the backend `getClimatiqUnitType` (g17eco/apps/emissions/src/util/climatiqUtils.ts):
 * Climatiq's vocabulary is Volume | Weight | Energy | Distance, so
 * `Area` and `Count` activities (e.g. SquareMeters, Each) intentionally
 * return `undefined` — there's no Climatiq filter that fits them, and
 * the backend search treats `undefined` as "no constraint".
 *
 * Used by callers of `FactorSearchModal` so the modal's pinned Unit Type
 * always reflects the activity itself, not whatever the previous factor
 * happened to advertise (a failed calculation has no prior factor at
 * all, see GU-7017).
 */
import { UNIT_CATEGORIES, type ActivityUnit } from '@g17eco/emissions-config';

const CLIMATIQ_UNIT_TYPES = new Set(['Volume', 'Weight', 'Energy', 'Distance']);

export const getActivityUnitType = (unit: ActivityUnit | undefined): string[] | undefined => {
  if (!unit) return undefined;
  const category = UNIT_CATEGORIES[unit];
  if (!category || !CLIMATIQ_UNIT_TYPES.has(category)) return undefined;
  return [category];
};
